import { useQuery } from "@tanstack/react-query";
import { TaxonomieApi } from "../taxonomie.api";

export const taxonomieKeys = {
  all: ["taxonomie"] as const,
};

/**
 * La taxonomie ne bouge qu'au seed : on la garde une heure en cache plutôt que
 * de la redemander à chaque ouverture d'un panneau de pièces.
 */
export const useTaxonomieQuery = () =>
  useQuery({
    queryKey: taxonomieKeys.all,
    queryFn: () => TaxonomieApi.getTaxonomie(),
    staleTime: 60 * 60 * 1000,
    retry: false,
  });
